export default __webpack_public_path__ + "static/media/azure.2682b49b.svg";